/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = SplittingItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SplittingItemsEditor extends _Ext.ItemGridEditor<SplittingItemsRow> {



        protected getColumnsKey() { return "Production.SplittingItems"; }
        protected getDialogType() { return SplittingItemsDialog; }
        protected getLocalTextPrefix() { return SplittingItemsRow.localTextPrefix; }
        protected form: SplittingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }
        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            //this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            this.view.refresh();

        }
        public setEditValue(source: DismantlingRow, property) {
            //   super.setOwnerEntity(source); 
            super.setEditValue(source, property);
        }

        private distributeInteger(total, divider) {
            var list=[];
            if (divider === 0) {
                return 0
            } else {
                let rest = total % divider
                let result = total / divider

                for (let i = 0; i < divider; i++) {
                    if (rest-- > 0) {
                        list.push(Math.ceil(result))
                    } else {
                        list.push(Math.floor(result))
                    }
                }
            }
            return list;
        }
    
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: "Create Sub Bags",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {

                    var bag = (this.parentDialog as SplittingDialog).bagselected;
                    var noofbags = (this.parentDialog as SplittingDialog).form.NoOfSubBag.value;
                    var noofpieces = (this.parentDialog as SplittingDialog).form.EachSubBagPieces.value;
                    var itempieces = (this.parentDialog as SplittingDialog).form.Pieces.value;
                    var itemparts = (this.parentDialog as SplittingDialog).form.Parts.value;
                    var Parts = (this.parentDialog as SplittingDialog).form.EachSubBagParts.value;

                    if (bag == undefined || noofbags == null || noofpieces == null || itempieces == null || itemparts == null || Parts == null) {
                        q.alert("", "Some Fields Missing!", true, 2999);
                        return;
                    }


                    this.setData(bag, noofbags, noofpieces, itempieces, itemparts, Parts, (this.parentDialog as SplittingDialog).bomDetails);
                }
            });
            return buttons;
        }

        setData(selectedrow: SplittingItemsRow, bagcount: number, noofpieces: number, itempieces: number, itemparts: number, Parts: number, bomDetails: any[]) {
            this.view.setItems([]);
            var subbagno = 0;
            var bags = this.distributeInteger(itempieces, bagcount);

            var bagspossible = Math.floor((itempieces) / noofpieces);
            var piecesleft = (itempieces) - (bagcount * noofpieces);
            if (itempieces == 1 && itemparts > 1) {
                subbagno = subbagno + 1;

                subbagno = isNaN(selectedrow.SubBagNo) ? 0 : selectedrow.SubBagNo;
                this.setnewitem(selectedrow, 1, bomDetails, 1, Parts, subbagno);

                bagcount -= 1;
                var remainingbags = bagcount;
                var remainingparts = itemparts - Parts;
                for (var i = 0; i < remainingbags; i++) {

                    if (remainingparts >= Parts) {
                        remainingparts -= Parts;
                        subbagno += 1;

                        this.setnewitem(selectedrow, 0, bomDetails, 0, Parts, subbagno);
                    }
                }
                if (remainingparts > 0) {
                    subbagno += 1;

                    this.setnewitem(selectedrow, 0, bomDetails, 0, remainingparts, subbagno);
                }
            }
            else if (piecesleft > 0) {
                subbagno = isNaN(selectedrow.SubBagNo) ? 0 : selectedrow.SubBagNo;
                for (var i = 0; i < bagcount; i++) {
                    subbagno += 1;

                    this.setnewitem(selectedrow, itempieces, bomDetails, noofpieces, itemparts, subbagno);
                }
                this.setnewitem(selectedrow, itempieces, bomDetails, piecesleft, itemparts, subbagno + 1);

            }
            else if (piecesleft == 0) {
                subbagno = isNaN(selectedrow.SubBagNo) ? 0 : selectedrow.SubBagNo;
                for (var i = 0; i < bagcount; i++) {
                    subbagno += 1;

                    this.setnewitem(selectedrow, itempieces, bomDetails, noofpieces, itemparts, subbagno);
                }
            } else if (piecesleft < 0) {
                subbagno = isNaN(selectedrow.SubBagNo) ? 0 : selectedrow.SubBagNo;
                for (var i = 0; i < bagspossible; i++) {
                    subbagno += 1;
                    this.setnewitem(selectedrow, itempieces, bomDetails, noofpieces, itemparts, subbagno);

                }

                var remainingbags = bagcount - bagspossible;
                for (var i = 0; i < remainingbags; i++) {
                    subbagno += 1;
                    this.setnewitem(selectedrow, 0, bomDetails, 0, itemparts, subbagno);

                }
            }

        }

        setnewitem(selectedrow: WIPMovementRow, itempieces: number, bomDetails: WIPTransactionRow[], noofpieces: number, Parts: number, subbagno: number) {
            var value = selectedrow;
            var newbom = [];
            var bomdetails = bomDetails;
            if (bomdetails != undefined) {
                for (var j = 0; j < bomdetails.length; j++) {
                    var oldbom = bomdetails[j];
                    var bom: SplittingBOMRow = {
                        BagNo: selectedrow.BagNo,
                        BomProductId: oldbom.ProductId,
                        ItemTypeId:oldbom.ItemTypeId,
                        AttributeId: oldbom.AttributeId,
                        CompanyId: oldbom.CompanyId,
                        FinancialYearId: oldbom.FinancialYearId,
                        Line_No: oldbom.Line_No==null?0:oldbom.Line_No,
                        Pieces: oldbom.Pieces / itempieces,
                        Weight: oldbom.Weight / itempieces,
                        ProductId: oldbom.ProductId,
                        PureWeight: oldbom.PureWeight,
                        Purity: oldbom.Purity,
                        RefTransBomId: oldbom.StockId,
                        RefTransId: oldbom.TransId, 
                        RefVoucherId: oldbom.VoucherTypeId,
                        SettingId: oldbom.SettingId,
                        Lab: oldbom.Lab,
                        StoneStatusId: oldbom.StoneStatusId,
                        CertificateNo: oldbom.CertificateNo,
                        CalcOnId: oldbom.CalcOnId,
                        LotNo: oldbom.LotNo,
                        UserId: oldbom.EmployeeId,
                        IsCustomerItem: oldbom.IsCustomerItem
                        
                    };
                    newbom.push(bom);
                }
            }

            var item: SplittingItemsRow = {
                ProductId: value.ProductId,
                ProductCode: value.ProductCode,
                AttributeId: value.AttributeId,
                ItemTypeId: value.ItemTypeId,
                Line_No: value.Line_No,
                BagNo: selectedrow.BagNo,
                SubBagNo: subbagno,
                DepartmentId: selectedrow.DepartmentId,
                Pieces: noofpieces,
                EmployeeId: 0,
                Weight: (value.Weight / itempieces) * noofpieces,
                Parts: Parts,
                OtherPieces: value.OtherPieces,
                OtherWeight: value.OtherWeight,
                StonePieces: value.StonePieces,
                StoneWeight: value.StoneWeight,
                NetWeight: (value.NetWeight / itempieces) * noofpieces,
                DiamondPieces: value.DiamondPieces,
                DiamondWeight: value.DiamondWeight,
                RefTransId: value.TransId,
                RefTransItemId: value.TransItemId,
                RefVoucherId: value.VoucherTypeId,
                DeliveryDate: "1/1/2021 9:00:00.2492948 AM",
                RefVoucherNo: value.VoucherNo,
                Attribute: value.Attribute,
                Purity: value.Purity,
                PureWeight: value.PureWeight,
                TreeId: value.TreeId,
                TreeItemId: value.TreeItemId,
                TreeNo: value.TreeNo,
                BOMDetails: newbom,
                OrderTypeId: value.OrderTypeId,

            };

            item[this.getIdProperty()] = "`" + this.nextId++;
            this.view.addItem(item);
        }
       

      

        // #region Buttons Add-Remove
     
    }
}